const classNames = (...args) => {
    const classes = [];

    for (const arg of args) {
        const argType = typeof arg;
        if (argType === 'string' && arg) {
            classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
            const inner = classNames(...arg);
            if (inner) {
                classes.push(inner);
            }
        } else if (argType === 'object' && arg) {
            for (const key in arg) {
                if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) {
                    classes.push(key);
                }
            }
        }
    }

    return classes.join(' ');
};

export default classNames;
